export default "__VITE_ASSET__B7NQa4IT__"